import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings } from '../models/app-settings.model';

@Injectable()
export class ConfigService {
	appSettings: AppSettings;

	constructor(private _http: HttpClient) {
		this.appSettings = new AppSettings();
	}

	load(): Promise<AppSettings> {
		return this._http.get<AppSettings>('app-settings.json')
			.toPromise<AppSettings>()
			.then(res => this.appSettings = res);
	}

}
